import { React, useState } from 'react';

import Box from '@mui/material/Box';
import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';

import InserirFalhasBulk from '../../components/inserirFalhaBulk';
import InserirFalhaIndividual from '../../components/inserirFalhaIndividual';
import PageHeader from '../../components/pageHeader';
import SettaSwitch from '../../components/settaSwitch';
import '../css/failureEntry.css';

const InserirFalhas = () => {
    const [tipo, setTipo] = useState('individual');
    const isBulk = tipo === 'bulk';

    return (
        <Box className='mainBox failure-entry-page'>
            <PageHeader>{isBulk ? 'Inserir Falhas CSV' : 'Inserir Falhas'}</PageHeader>

            <Box className='failure-entry-mode-panel'>
                <Box className='failure-entry-mode-copy'>
                    {isBulk ? <TableChartRoundedIcon /> : <BugReportRoundedIcon />}
                    <Box>
                        <span>Modo de lançamento</span>
                        <strong>{isBulk ? 'Envio por CSV' : 'Inserção individual'}</strong>
                    </Box>
                </Box>

                <Box className='failure-entry-mode-switch'>
                    <span>Individual</span>
                    <SettaSwitch
                        checked={isBulk}
                        onChange={(checked) => setTipo(checked ? 'bulk' : 'individual')}
                        ariaLabel='Alternar entre inserção individual e CSV'
                    />
                    <span>CSV</span>
                </Box>
            </Box>

            {isBulk ? <InserirFalhasBulk /> : <InserirFalhaIndividual /> }
        </Box>
    );
};

export default InserirFalhas;
